import { Modal } from 'antd';
import * as React from 'react';

class ReloadModal extends React.Component<ReloadModalProps, ReloadModalState> {
    constructor(props: ReloadModalProps) {
        super(props);
        this.state = { show: false };
        this.reload = this.reload.bind(this);
        this.cancel = this.cancel.bind(this);
    }

    public componentDidMount() {
        // Handle global event.
        window.addEventListener('newContentAvailable', () => {
            this.setState({
                show: true
            });
        });
    }

    private reload(event: React.MouseEvent<any>) {
        // Reload when clicked.
        window.location.reload();
    }

    private cancel(event: React.MouseEvent<any>) {
        this.setState({ show: false });
    }

    public render() {
        return (
            <Modal
                okText="reload page"
                visible={this.state.show}
                okType="primary"
                onOk={this.reload}
                onCancel={this.cancel}
            >
                There is a new version of V-Sponse available. Please reload this page.
            </Modal>
        );
    }
}

interface ReloadModalProps {}

interface ReloadModalState {
    show: boolean;
}

export default ReloadModal;



// WEBPACK FOOTER //
// ./src/components/ReloadModal.tsx